import React from 'react';
import {
  useInvalidateQueries,
  useUpdateRecord,
  useCreateRecord,
} from 'src/api/APIHooks';
import { defaultMutationConfig } from 'src/components/Backoffice/api/hooks/apiHookOptions';
import PropTypes from 'prop-types';
import { Form, Field } from 'react-final-form';
import { Button, SelectField } from '@unite-us/app-components';

export const useUpdateCase = () => {
  const invalidateQueries = useInvalidateQueries();
  return useUpdateRecord('case', {
    mutationConfig: {
      onSuccess: () => {
        invalidateQueries('cases');
      },
    },
  });
};

const useCreateNote = () => {
  const invalidateQueries = useInvalidateQueries();
  return useCreateRecord('note', {
    mutationConfig: {
      onSuccess: () => {
        invalidateQueries('notes');
      },
      ...defaultMutationConfig,
    },
  });
};

const ClientNeedForm = ({
  closeModal,
  selectedConditionId,
  conditions,
  caseId,
  modalIsOpen,
  reloadCase,
  currentEmployeeId,
}) => {
  const { updateRecord: updateCase } = useUpdateCase();
  const { createRecord: createNote } = useCreateNote();

  const personConditions = conditions.map((condition) => ({
    label: condition.name,
    value: condition.id,
  }));

  const onSubmit = async (formInputs) => {
    if (selectedConditionId !== formInputs.client_need) {
      const originalClientNeed = conditions.find((condition) => condition.id === selectedConditionId)?.name;
      const newClientNeed = conditions.find((condition) => condition.id === formInputs.client_need)?.name;

      await Promise.all([
        updateCase(caseId, formInputs),
        createNote({
          text: `Associated need changed from ${originalClientNeed} to ${newClientNeed}`,
          subjectType: 'case',
          subject: caseId,
          employee: currentEmployeeId,
          category: 'general',
          details: { deletable: false, type: 'update' },
        }),
      ]).then(() => {
        reloadCase();
      });
    }
    closeModal();
  };

  if (!modalIsOpen) {
    return null;
  }

  return (
    <Form
      onSubmit={onSubmit}
      initialValues={{ client_need: selectedConditionId }}
      render={({ handleSubmit, submitting }) => (
        <form className="mt-4" onSubmit={handleSubmit}>
          <div style={{ marginBottom: '115px' }}>
            <Field
              name="client_need"
              render={({ input }) => (
                <SelectField
                  id="service-case-reason"
                  label="Associated Need"
                  options={personConditions}
                  {...input}
                  required
                  placeholder="Pick One"
                />
              )}
            />
          </div>
          <div className="actions">
            <span className="action-item">
              <Button
                id="description-cancel-btn"
                label="Cancel"
                onClick={closeModal}
                disabled={submitting}
              />
            </span>
            <span className="action-item">
              <Button
                id="description-submit-btn"
                onClick={handleSubmit}
                primary
                disabled={submitting}
                label="Submit"
              />
            </span>
          </div>
        </form>
      )}
    />
  );
};

ClientNeedForm.propTypes = {
  closeModal: PropTypes.func.isRequired,
  selectedConditionId: PropTypes.string.isRequired,
  conditions: PropTypes.array.isRequired,
  caseId: PropTypes.string.isRequired,
  modalIsOpen: PropTypes.bool.isRequired,
  reloadCase: PropTypes.func.isRequired,
  currentEmployeeId: PropTypes.string.isRequired,
};

ClientNeedForm.contextTypes = {
  eventTracker: PropTypes.func.isRequired,
};

export default ClientNeedForm;
